export default __webpack_public_path__ + "static/media/instrucciones.47ea2e36.png";